import {
  VCTOKEN_ERROR,
  VCTOKEN_LOADING,
  VCTOKEN_SUCCESS,
  VCTOKEN_RESET,
  RESET_PORTAL_CONTEXT,
} from "../ActionTypes";

import vcTokenInitialState from "../initialStates/vcTokenInitialState";

const vcToken = (state, { payload, type }) => {
  switch (type) {
    case VCTOKEN_LOADING:
      return {
        ...state,
        vcToken: {
          ...state.vcToken,
          error: false,
          loading: true,
        },
      };
    case VCTOKEN_SUCCESS:
      return {
        ...state,
        vcToken: {
          ...state.vcToken,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case VCTOKEN_ERROR:
      return {
        ...state,
        vcToken: {
          ...state.vcToken,
          error: payload,
          loading: false,
          data: null,
        },
      };

    case VCTOKEN_RESET:
      return vcTokenInitialState;
      
    case RESET_PORTAL_CONTEXT:
      return vcTokenInitialState;

    default:
      return state;
  }
};

export default vcToken;
